/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";

import { IconButton, useMediaQuery } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import { TransitionProps } from "@mui/material/transitions";
import { XIcon } from "components";
import { DialogFieldName, useDialog } from "stores/Dialog";
import { i18n } from "translations";
import { rem } from "utils";

import LoadingOverlay from "./LoadingOverlay";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface CommonDialogProps {
  name: DialogFieldName;
  open?: boolean;
  width?: number;
  onToggle?: () => void;
  title?: string;
  titleI18n?: string;
  dialogProps?: Partial<React.ComponentProps<typeof Dialog>>;
  hideCloseButton?: boolean;
  action?: React.ReactNode;
  children?: React.ReactNode;
  loading?: boolean;
}

const CommonDialog: React.FC<CommonDialogProps> = ({
  name,
  open,
  width,
  title,
  titleI18n,
  dialogProps,
  hideCloseButton = false,
  action,
  children,
  loading,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(820));
  const {
    dialog: { show },
    onToggle,
  } = useDialog({ name });

  const handleClose = (_event: any, reason: string) => {
    if (reason && reason === "backdropClick") return;
    onToggle();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      scroll="paper"
      open={open || show}
      onClose={handleClose}
      disableEscapeKeyDown
      sx={{
        ...(width && {
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: `${width}px`,
            },
          },
        }),
      }}
      {...dialogProps}
    >
      <DialogTitle
        sx={{
          position: "sticky",
          top: 0,
          left: 0,
          zIndex: 1,
          backgroundColor: "white",
        }}
      >
        {titleI18n ? i18n.t(titleI18n) : title}
        {!hideCloseButton && (
          <IconButton
            aria-label="close"
            onClick={onToggle}
            sx={{
              position: "absolute",
              right: 15,
              top: 15,
              zIndex: 999,
            }}
          >
            <XIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        <LoadingOverlay loading={loading}>{children}</LoadingOverlay>
      </DialogContent>
      {action && (
        <DialogActions
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#FFFFFF",
            padding: `${rem(16)} ${rem(24)}`,
            borderRadius: "12px",
          }}
        >
          {action}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CommonDialog;
